var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66667 9H6.33333C6.70152 9 7 9.39175 7 9.875V16H3V9.875C3 9.39175 3.29848 9 3.66667 9Z",
    stroke: "#004AF7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66667 2H10.3333C10.7015 2 11 2.39175 11 2.875V16H7V2.875C7 2.39175 7.29848 2 7.66667 2Z",
    stroke: "#004AF7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.33333V6.83333C15 6.3731 14.7015 6 14.3333 6H11.6667C11.2985 6 11 6.3731 11 6.83333V16H12.3333",
    stroke: "#004AF7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15.5C22 16.1922 21.7947 16.8689 21.4101 17.4445C21.0256 18.0201 20.4789 18.4687 19.8394 18.7336C19.1999 18.9985 18.4961 19.0678 17.8172 18.9327C17.1383 18.7977 16.5146 18.4644 16.0251 17.9749C15.5356 17.4854 15.2023 16.8617 15.0673 16.1828C14.9322 15.5039 15.0015 14.8001 15.2664 14.1606C15.5313 13.5211 15.9799 12.9744 16.5555 12.5899C17.1311 12.2053 17.8078 12 18.5 12",
    stroke: "#004AF7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 14V16H19.5",
    stroke: "#004AF7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTransaction);
export default __webpack_public_path__ + "static/media/dashboard-transaction.8de8c06b.svg";
export { ForwardRef as ReactComponent };